import React, { forwardRef, useCallback } from 'react';
import { Pressable } from 'react-native';
const TouchableBounce = forwardRef(({ style, onPress, children, hoverStyle, onHoverChange, onHoverIn, onHoverOut, ...props }, ref) => {
    const [isHovering, setIsHovering] = React.useState(false);
    // Calls the caller's own hover handlers too, so passing one doesn't stop the
    // hover style or onHoverChange from updating
    const handleHoverIn = useCallback((event) => {
        setIsHovering(true);
        onHoverChange?.(true);
        onHoverIn?.(event);
    }, [onHoverChange, onHoverIn]);
    const handleHoverOut = useCallback((event) => {
        setIsHovering(false);
        onHoverChange?.(false);
        onHoverOut?.(event);
    }, [onHoverChange, onHoverOut]);
    return (<Pressable ref={ref} onPress={onPress} onHoverIn={handleHoverIn} onHoverOut={handleHoverOut} style={[style, isHovering && hoverStyle]} {...props}>
        {children}
      </Pressable>);
});
export default React.memo(TouchableBounce);
